import { AdditionalFormField } from './request-header.model';
export class ExternalRequestModel {
  id: number;
  hotel_id: number;
  profile_name: string;
  phone_no: string;
  locale: string;
  capacity_name: string;
  note: string; // Misafirin yazdığı not
  type: string; // room_service, reservation, reservation_to_facility, housekeeping_request, complaint, issue, premium_service, restaurant_order
  menu_item_id: number;
  order_date: Date;
  amount: number;
  request_lines: ExternalRequestLineModel[];
  additional_form_fields: AdditionalFormField[];

}

export class ExternalRequestLineModel {
  type: string;
  no: number;
  line_no: number;
  name: string;
  description: string;
  quantity: number;
  unit_price: number;
  currency_code: string;
  amount: number;
  request_time: string;
  unit_of_measure: string;
  note:string;
}
